if (typeof G == 'undefined') G = {};


G.FrameAnimation = function(x,y,frameName,frameRate,autoPlay) {

	Phaser.Image.call(this,game,G.l(x),G.l(y));

	this.anchor.setTo(0.5);

	this.frameNamePrefix = frameName;
	this.animFramesLen = this.getAnimationLength(this.frameNamePrefix);

	this.timerEvery = frameRate ? (60/frameRate) : 1;
	this.animDir = 1;

	G.changeTexture(this,this.frameNamePrefix+'_0');

	this.currentTimer = 0;
	this.currentIndex = 0;

	this.onFinish = new Phaser.Signal();

	this.active = autoPlay || false;
	

};

G.FrameAnimation.prototype = Object.create(Phaser.Image.prototype);

G.FrameAnimation.prototype.play = function(loop,bounce,startFrame) {

	this.currentTimer = 0;
	this.currentIndex = startFrame || 0;
	this.active = true;
	this.loop = loop-1 || 0;
	this.animDir = 1;
	this.bounce = bounce || false;
	G.changeTexture(this,this.frameNamePrefix+'_'+this.currentIndex);

	return this;

};

G.FrameAnimation.prototype.update = function() {

	if (!this.active) return;

	this.currentTimer+=G.deltaTime

	if (this.currentTimer >= this.timerEvery) {

		this.currentTimer = this.currentTimer-this.timerEvery;
		this.currentIndex += this.animDir;

		if (this.bounce) {
			if (this.currentIndex == this.animFramesLen || this.currentIndex == 0) {

				if (this.loop == 0 && this.currentIndex == 0) {
					this.onFinish.dispatch();
					return this.active = false;
				}

				if (this.loop > 0 && this.currentIndex == 0) {
					this.loop--;
				}

				if (this.currentIndex == this.animFramesLen) this.currentIndex = this.animFramesLen-1;
				
				this.animDir *= -1;

			}
		}else {

			if (this.currentIndex == this.animFramesLen) {
				if (this.loop == 0) {
					this.onFinish.dispatch();
					return this.active = false;
				}
				if (this.loop > 0) this.loop--;

				this.currentIndex = 0;

			}

		}

		G.changeTexture(this,this.frameNamePrefix+'_'+this.currentIndex);

	}

};

G.FrameAnimation.prototype.getAnimationLength = function(frameNamePrefix) {

	if (G.FrameAnimation.CacheAnimLength[frameNamePrefix]) return G.FrameAnimation.CacheAnimLength[frameNamePrefix];

	var len = 0;

	for (var i = 0; i < 1000; i++) {
		if (G.isImageInCache(frameNamePrefix+'_'+i)) {
			len++;
		}else {
			break;
		}
	}

	G.FrameAnimation.CacheAnimLength[frameNamePrefix] = len;

	return len;

};

G.FrameAnimation.CacheAnimLength = {};